import { trackPromise } from 'react-promise-tracker';
import { GerenciadorPrecos } from '../../../../../../@types/GerenciadorPrecos';
import { api } from '../../../../../../lib';
import { RuleCompositionData } from '../../../../../../reducers/ipa/priceManager/modals/ruleComposition';

export const getRuleCompositionOfferData = async (offer: NonNullable<GerenciadorPrecos.RowData['offer']>): Promise<RuleCompositionData> => {
  const queryFn = async () => {
    const response = await api.get(`/rules/composition/${offer.ruleId}?productsToBePricedId=${offer.id}`, {
      expectToken: true,
    });
    return response.data;
  };

  return await trackPromise(queryFn(), 'composition-rule-offer');
};
